import React, { useState } from 'react'

const TextForm = (props) => {
    const [text, setText] = useState("");
    const changeMethod = (e) => {
        setText(e.target.value)
    }
    const removeExtraSpaces=()=>{
        let newtext= text.replace(/\s+/g, ' ').trim();
        setText(newtext)
      }
    const handleUpCase = (e) => {
        let newText = text.toUpperCase()
        setText(newText)
        props.showAlert("Converted to UpperCase", "success")
    }
    const handleLowerCase = () => {
        let newText = text.toLowerCase()
        setText(newText)
        props.showAlert("Converted to lowerCase", "success")
    }
    const handleClearText = (e) => {
        setText("");
        props.showAlert("Text has been cleared", "success")
    }
    return (

        <div className='my-4 container' >
            <h1 style={{ color: props.mode === "light" ? "black" : "white" }}>{props.heading} </h1>
            <div className="mb-3" style={{ color: props.mode === "light" ? "black" : "white" }}>
                <label htmlFor="exampleFormControlTextarea1" className="form-label">Example text area</label>
                <textarea className="form-control" style={{ backgroundColor: props.mode === "dark" ? "#01030d" : "white", color: props.mode === "light" ? "black" : "white" }} value={text} placeholder='Enter the Text Here' onChange={changeMethod} id="myBox" rows="8"></textarea>
            </div>
            <button className="btn btn-primary mx-1 my-2" disabled={text.length===0} onClick={handleUpCase}>Convert to UpperCase</button>
            <button className="btn btn-primary mx-1 my-2" disabled={text.length===0} onClick={handleLowerCase}>Convert to LowerCase</button>
            <button className="btn btn-primary mx-1 my-2" disabled={text.length===0} onClick={handleClearText}>Clear Text</button>
            <button className="btn btn-primary mx-1 my-2" disabled={text.length===0} onClick={removeExtraSpaces}>Remove Extra Spaces</button>
            <div className="container my-3" style={{ color: props.mode === "light" ? "black" : "white" }}>
                <h1>Your Text Here</h1>
                <p>Words {text.split(" ").filter((e)=>{return e.length!==0}).length} characters {text.length}</p>
                <p> {0.08 * text.split(" ").filter((e)=>{return e.length!==0}).length} Minutes to read</p>
                <h3>Preview</h3>
                <p>{text}</p>
            </div>
        </div>

    )
}

export default TextForm;